<template>
  <modal :showing="is_video_selected && !!video" @close="close_video">
    <template v-if="video">

      <!-- Player -->
      <vue-plyr>
        <div
          v-if="isYoutube"
          data-plyr-provider="youtube"
          :data-plyr-embed-id="youtubeId"
        ></div>

        <video
          v-else
          :poster="video.picture ? video.picture.large : undefined"
          :src="video.url"
          autoplay
          loop
          playsinline
        >
          <source :src="video.url" type="video/mp4" />
        </video>
      </vue-plyr>

      <!-- Meta -->
      <div class="px-6 py-5">
        <h2 class="text-xl font-bold text-gray-900 leading-snug">{{ video.title }}</h2>

        <p v-if="video.teaser" class="mt-2 text-gray-500 text-sm leading-relaxed">{{ video.teaser }}</p>

        <div v-if="video.tags && video.tags.length" class="flex flex-wrap gap-2 mt-4">
          <span
            v-for="tag in video.tags"
            :key="tag.id"
            class="px-3 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-600"
          >{{ tag.title }}</span>
        </div>
      </div>

    </template>
  </modal>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useVideoStore } from '../stores'
import Modal from './modal.vue'
import VuePlyr from './vue-plyr.vue'

export default {
  computed: {
    ...mapState(useVideoStore, ['selected_video_id', 'selected_video']),
    is_video_selected() {
      return this.selected_video_id != null
    },
    video() {
      return this.selected_video
    },
    isYoutube() {
      return this.video?.url?.includes('youtu')
    },
    youtubeId() {
      const match = this.video?.url?.match(/(?:youtu\.be\/|v=)([^&/?]+)/)
      return match ? match[1] : null
    }
  },
  methods: {
    ...mapActions(useVideoStore, ['select_video']),
    close_video() {
      this.select_video(null)
    }
  },
  components: { Modal, VuePlyr }
}
</script>
